export function getUser() {
  let user = JSON.parse(localStorage.getItem("user_paboi"));
  if (user) {
    return user.data;
  } else {
    return null;
  }
}
